import React, { PureComponent } from 'react';
import { deleteEntries } from 'AppSrc/core/utility-functions/array-fun';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { IndividualApprovers } from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/individual-approvers';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { FieldTitle } from './sub-components/field-title';
import { InlineErrors } from './sub-components/inline-errors';
import {
  vFParamsPropShape,
  vFButtonSelectorOptionShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-multi-select.css';

// finds duplicated display options
const isDisplayOptionOverridden = (value, overridingOptions = []) => overridingOptions.some((overridingOption) => overridingOption.duplicatesDisplayOptionWithValue === value);

// Some values overide values have a displayOption that duplicates them that needs removing
const filterOutDuplicatedDisplayOptions = (displayOptions, overridingOptions = []) => displayOptions.filter((displayOption) => {
  const thisDisplayValue = displayOption.value;
  const overridingOptionIsDuplicut = isDisplayOptionOverridden(thisDisplayValue, overridingOptions);
  return !overridingOptionIsDuplicut;
});

// for a given array of values, this removes the values that can only be reached by an overridingOption
const filterOutOverideOnlyValues = (values, overridingOptions = []) => values.filter((value) => !isDisplayOptionOverridden(value, overridingOptions));






class VFMultiSelectBase extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      overridingOptionSelected: null,
      searchInput: '',
      filteredDisplayOptions: [],
      groupData: '',
    };
    this.updateValue = this.updateValue.bind(this);
    this.setOverridingOption = this.setOverridingOption.bind(this);
    this.searchHandler = this.searchHandler.bind(this);
  }

  componentDidMount() {
    this.resetDisplayOptions();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.displayOptions !== this.props.displayOptions) {
      this.resetDisplayOptions();
    }
  }

  setOverridingOption(overridingOption) {
    const {
      setValue,
    } = this.props;


    const {
      overridingOptionSelected,
    } = this.state;

    const {
      values,
      id,
    } = overridingOption;

    if (overridingOptionSelected === id) {
      setValue([]);

    }
    else {
      setValue(values);
    }

    this.setState((prevState) => {
      const prevOverridingOptionSelected = prevState.overridingOptionSelected;
      if (prevOverridingOptionSelected === id) {
        return ({
          overridingOptionSelected: null,
        });
      }
      return ({
        overridingOptionSelected: id,
      });
    });
  }


  updateValue(valueToAdd) {
    const {
      vFParams,
      value,
      setValue,
    } = this.props;


    const {
      overridingOptionSelected,
    } = this.state;

    const {
      overridingOptions,
    } = vFParams;


    const currentValue = value ? value : []; // if the value is null, we set it to an empty array.

    let multiSelectValue = [];

    if (currentValue.includes(valueToAdd)) {
      multiSelectValue = deleteEntries(currentValue, valueToAdd);
    }
    else {
      // if a value can only be selected via a overriding display option, we want to remove that value from the "currentValue" array
      const maintainedValues = filterOutOverideOnlyValues(currentValue, overridingOptions);
      multiSelectValue = [
        ...maintainedValues,
        valueToAdd,
      ];
    }


    setValue(multiSelectValue);
    if (overridingOptionSelected) {
      this.setState({
        overridingOptionSelected: null,
      });
    }
  }

  searchHandler(event) {
    // Search func for filter array by searching any related text keywords
    const {
      displayOptions,
    } = this.props;

    const searchQuery = event.toLowerCase();
    if (searchQuery) {
      this.setState({
        filteredDisplayOptions: displayOptions.filter((el) => el.text.toLowerCase().includes(searchQuery)),
      });
    }
    else {
      this.resetDisplayOptions();
    }

    this.setState({
      searchInput: event,
    });
  }

  resetDisplayOptions() {
    const {
      displayOptions,
    } = this.props;

    this.setState({ filteredDisplayOptions: displayOptions });
    this.setState({
      groupData: displayOptions,
    });
  }

  render() {

    const {
      displayOptions,
      readOnly,
      disabledFieldOptions,
      optional,
      vFParams,
      name,
      value,
      errors,
      touched,
      displayText,
    } = this.props;

    const {
      overridingOptionSelected,
      filteredDisplayOptions,
    } = this.state;

    const {
      fieldTitle,
      displayType,
      // displays at the top and clears the selection if selected, replacing the fields value with it's values
      overridingOptions,
    } = vFParams;

    // We don't display the field title if the display is 'big'
    // However we still need to provide a field title for the summary page
    const displayFieldTitle = fieldTitle && displayType !== 'big';

    const displayClassName = displayType ? displayType : 'standard';

    // To get correct network and form section from url
    const url = window.location.href;

    const urlSplit = url.split('/');

    const stepIdUrl = url.split('/').slice(-1).join('/');

    const createCrqNetwork = urlSplit[urlSplit.length - 2];

    const updateCrqNetwork = urlSplit[urlSplit.length - 3];

    const filteredData = !overridingOptions ? filteredDisplayOptions : filterOutDuplicatedDisplayOptions(filteredDisplayOptions, overridingOptions);

    const {
      disabled,
    } = disabledFieldOptions;

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const safeValue = value ? value : []; // if the value is null, we set it to an empty array.


    const classNameBase = 'v-f-multi-select';

    const classNameList = [
      'v-f-field-type',
      classNameBase,
      `${classNameBase}-${displayClassName}`,
      `${classNameBase}-${name}`,
    ];

    if (disabled) {
      classNameList.push(`${classNameBase}-disabled`);
    }
    if (readOnly) {
      classNameList.push(`${classNameBase}-read-only`);
    }

    const className = classNameList.join(' ');



    return (
      <>
        <div
          className={className}
          name={name}
        >
          {
            displayFieldTitle && (
              <FieldTitle
                fieldTitle={fieldTitle}
                optional={optional}
              />
            )
          }
          <div className="multi-select-body">
            <div className="display-value">
              <span>{displayText}</span>
            </div>
            { // Search div when default array length > 5
              displayOptions.length > 5 && (
                <div className="search-drop">
                  <input
                    className="Search-Input"
                    type="text"
                    onChange={(e) => this.searchHandler(e.target.value)}
                    placeholder=" Please Search Here..."
                    value={this.state.searchInput}
                  />
                  <div className={`no-result-msg ${filteredDisplayOptions.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
                </div>
              )
            }
            <ul className="multi-select-options">
              {
                overridingOptions && overridingOptions.length > 0 && (
                  <ul className="multi-select-overriding-options">
                    {
                      overridingOptions.map((overridingOption, index) => {
                        const isSelectedByState = overridingOptionSelected === overridingOption.id;
                        const isSelectedByValue = safeValue.includes(overridingOption.duplicatesDisplayOptionWithValue);
                        // the component keeps track if the overidingOption is selected. However when the overridingOption
                        // provides a unique value, we need to figure out if it is selected between mounts
                        const isSelected = isSelectedByState || isSelectedByValue;
                        return (
                          <li
                            /* eslint-disable-next-line  react/no-array-index-key */
                            key={`${overridingOption.i}-${index}`}
                          >
                            <OptionButton
                              className={`multi-select-option ${isSelected ? 'multi-select-option-selected' : ''}`}
                              onClick={this.setOverridingOption}
                              option={overridingOption}
                            >
                              <div className="svg-container test1c">
                                {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
                              </div>
                              <p className="multi-select-option-text">
                                {overridingOption.text}
                              </p>
                            </OptionButton>
                          </li>
                        );
                      })
                    }
                  </ul>
                )
              }
              {
                filteredData.map((displayOption, index) => {
                  const isSelected = safeValue.includes(displayOption.value);
                  const isReadOnly = displayOption.readOnly ? true : false;
                  const baseCssClass = 'multi-select-option';
                  const cssClasses = [baseCssClass];
                  if (isSelected) { cssClasses.push(`${baseCssClass}-selected`); }
                  if (isReadOnly) { cssClasses.push(`${baseCssClass}-read-only`); }
                  return (
                    <li
                      /* eslint-disable-next-line  react/no-array-index-key */
                      key={`${displayOption.value}-${index}`}
                    >
                      <OptionButton
                        className={cssClasses.join(' ')}
                        onClick={this.updateValue}
                        option={displayOption.value}
                        disabled={isReadOnly}
                      >
                        <div className="svg-container test2c">
                          {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
                        </div>
                        <p className="multi-select-option-text">
                          {displayOption.text}
                        </p>
                      </OptionButton>
                    </li>
                  );
                })
              }
            </ul>
          </div>

          {
            inlineErrors && touched && (
              <InlineErrors
                inlineErrors={inlineErrors}
              />
            )
          }
        </div>
        <div className="select-individual">
          {
           (stepIdUrl === 'APPROVERS_SECTION' || stepIdUrl === '7') && (updateCrqNetwork === 'fixed' || createCrqNetwork === 'fixed') && this.state.groupData && (
             <IndividualApprovers
               displayOptions={displayOptions}
             />
           )
          }
        </div>
      </>
    );
  }
}



VFMultiSelectBase.propTypes = {
  vFParams: vFParamsPropShape,
  displayOptions: PropTypes.arrayOf(vFButtonSelectorOptionShape),
  disabledFieldOptions: disabledFieldOptionsShape,
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  setValue: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.any),
  name: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  touched: PropTypes.bool,
  displayText: PropTypes.string,
};




export {
  VFMultiSelectBase,
};
